<template>
    <div class="mw_box" :class="showTopTit ? 'pdTop' : ''">
        <TitLoading ref="titLoading"></TitLoading>
        <template v-if="withdrawArr.length !== 0">
            <div class="item" v-for="item in withdrawArr" :key="item.withdrawCode" @click="showDetailed(item)">
                <div class="item_top">
                    <div class="item_tl">
                        <img src="~assets/images/redEnvelopesImg/withdrawal_icon.png" alt="">
                        提现金额
                    </div>
                    <span>￥<i>{{item.amount / 100}}元</i></span>
                </div>
                <div class="item_bot">
                    <p><img src="~assets/images/redEnvelopesImg/code_icon.png" alt="">提现码:{{item.withdrawCode}}</p>
                    <div class="item_bd">
                        <div class="state_box">
                            <img src="~assets/images/redEnvelopesImg/bottom_icon.png" alt="">
                            进度状态
                        </div>
                        <span v-if="item.status === 0">审核中</span>
                        <span v-else class="on">已提现</span>
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="no_list">您还没有提现记录</div>
        <div class="mask" v-show="showMask">
			<div class="mask_bg" @click="showMask = false"></div>
			<div class="mask_wd" :class="maskData.status !== 0 ? 'mask_pd' : ''">
                <div class="wd_tit"><span>提现</span></div>
                <div class="wd_num"><span><i>￥</i>{{maskData.amount / 100}}</span></div>
                <div class="code">我的提现码：{{maskData.withdrawCode}}</div>
                <div class="ipt">
                    <img class="wechat_small" src="~assets/images/redEnvelopesImg/wechat_small.png" alt="">
                    <input type="text" v-model="wechatCode" :disabled="maskData.status === 0 ? false : true" placeholder="请输入微信号">
                    <img class="close_small" v-show="wechatCode" @click.stop="clearInput" src="~assets/images/redEnvelopesImg/close_small.png" alt="">
                </div>
                <div v-show="maskData.status === 0">
                    <van-button
                        class="btn"
                        :loading="btnLoading"
                        plain
                        :disabled="!wechatCode ? true : false"
                        type="primary"
                        @click.stop="getAccount"
                    >保存</van-button>
                    <div class="tp_main">
                        <p class="tit">提现流程</p>
                        <p><span>1</span>提现码已生成，请填写正确微信号并保存。</p>
                        <p><span>2</span>233乐园客服将在1-2个工作日内完成审核，审核通过之后233乐园客服将添加您的微信号并完成转账。</p>
                        <p>注：提现时间周一至周五10：00-19：00</p>
                    </div>
                </div>
				<img class="close_btn" @click="showMask = false" src="~assets/images/redEnvelopesImg/close_icon.png" alt="">
			</div>
		</div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import config from "@/../config";
import active from "@/utils/axios/index";
import primaryApi from "@/utils/primaryApi";
import TitLoading from "components/currency/titLoading"; // 共用的顶部导航和maskLoading
import { Button } from 'vant';
Vue.use(Button);
export default {
    data() {
        return {
            showTopTit: false, // 乐园显示顶部导航栏
            showMask: false, // 弹窗
            btnLoading: false, // 保存loading
            withdrawArr: [], // 提现记录
            maskData: {}, // 弹窗显示详细记录
            wechatCode: "", // 微信号
            withdrawCode: "", // 提现码
        }
    },
    components: {
		TitLoading
    },
    created() {
        if (primaryApi.isSource == "pd") {
            //乐园显示顶部导航栏
            this.showTopTit = true;
		}
        this.getWithdraw();
        this.$tea("event_active_redeem_list_page_show", {activityId: this.$route.query.activityId}); // 数据埋点
    },
    mounted() {
        this.$refs.titLoading.assignment("我的提现", ""); // 标题
    },
    methods: {
        // 获取提现记录
        getWithdraw() {
            active.getWithdraw(config.API_HOST + "/apiserv/api/activity/envelope/getWithdraw", {
                uuid: this.$route.query.uuid
            }).then((res) => {
                this.$refs.titLoading.assignment('', false);
                if (res.code != 200) {
                    this.$toast(res.message);
                    return;
                }
                this.withdrawArr = res.data;
            }).catch((error) => {
                this.$refs.titLoading.assignment('', false);
                this.$toast("网络不稳定，请稍后");
            });
        },
        // 查看记录详情
        showDetailed(item) {
            this.maskData = item;
            this.wechatCode = item.withdrawAccount;
            this.withdrawCode = item.withdrawCode;
            this.showMask = true;
            this.$tea("event_active_redeem_item_click", {activityId: this.$route.query.activityId}); // 数据埋点
            this.$tea("event_active_redeem_popup_show", {activityId: this.$route.query.activityId, page: "redeem_list_page"}); // 数据埋点
        },
        // 保存账号
        getAccount() {
            this.btnLoading = true;
            active.getAccount(config.API_HOST + "/apiserv/api/activity/envelope/account", {
                account: this.wechatCode,
                withdrawCode: this.withdrawCode
            }).then((res) => {
                this.btnLoading = false;
                if (res.code != 200) {
                    this.$toast(res.message);
                    return;
                }
                for(let i = 0; i < this.withdrawArr.length; i++) { // 同步更新账号
                    if (this.withdrawArr[i].withdrawCode == this.withdrawCode) {
                        this.withdrawArr[i].withdrawAccount = this.wechatCode;
                        break;
                    }
                }
                this.showMask = false;
                this.$toast("保存成功");
                this.$tea("event_active_save_account", {activityId: this.$route.query.activityId, accountype: "weixin", page: "redeem_list_page"}); // 数据埋点
            }).catch((error) => {
                this.btnLoading = false;
                this.$toast("网络不稳定，请稍后");
            });
        },
        // 清空输入框
        clearInput() {
            this.wechatCode = "";
            this.$tea("event_active_account_clear", {activityId: this.$route.query.activityId, page: "redeem_list_page"}); // 数据埋点
        }
    }
}
</script>
<style scoped>
.pdTop{
    padding-top: 46px;
}
.mw_box .item{
    border-bottom: 5px solid #F6F6F6;
    padding-bottom: 20px;
}
.mw_box .item:last-child{
    border-bottom: none;
}
.mw_box .item .item_top{
    color: #333;
    font-size: 15px;
    height: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px;
    border-bottom: 1px solid #F2EEF3;
}
.item_tl{
    display: flex;
    align-items: center;
}
.item_tl img{
    width: 18px;
    height: 17px;
    margin-right: 5px;
}
.mw_box .item .item_top span{
    color: #FF512E;
    font-size: 12px;
}
.mw_box .item .item_top span i{
    font-size: 15px;
}
.item_bot{
    padding: 0 13px;
    margin-top: 8px;
}
.item_bot p{
    color: rgba(51, 51, 51, 0.8);
    font-size: 15px;
    display: flex;
    align-items: center;
}
.item_bot p img{
    width: 19px;
    height: 13px;
    margin-right: 5px;
}
.item_bd{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
}
.state_box{
    display: flex;
    align-items: center;
    color: rgba(68, 68, 68, 0.8);
    font-size: 15px;
}
.state_box img{
    width: 17px;
    height: 17px;
    margin-right: 5px;
}
.item_bd span{
    background-color: #FF512E;
    color: #fff;
    font-size: 14px;
    width: 65px;
    height: 23px;
    text-align: center;
    display: inline-block;
}
.item_bd span.on{
    background-color: #03C04A;
}
.mask{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 151;
}
.mask_bg{
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.75);
}
.mask .mask_wd{
	position: absolute;
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -51%);
    transform: translateY(-50%, -51%);
    background-color: #fff;
    width: 311px;
    border-radius: 8px;
    padding-top: 20px;
    text-align: center;
}
.mask .mask_pd{
	padding-bottom: 25px;
}
.wd_tit{
    color: #262120;
    text-align: center;
    font-weight: 500;
    height: 21px;
    line-height: 21px;
    font-size: 15px;
    /* width: 130px; */
    position: relative;
}
.wd_tit::after{
    width: 130px;
    height: 1px;
    background-color: #C6C6C6;
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    content: "";
}
.wd_tit span{
    background-color: #fff;
    padding: 0 8px;
    position: relative;
    z-index: 1;
    font-size: 15px;
}
.wd_num{
    margin-top: 10px;
}
.wd_num span{
    color: #FF512E;
    font-size: 37px;
    position: relative;
}
.wd_num span i{
    font-size: 16px;
    position: absolute;
    bottom: 5px;
    left: -18px;
}
.mask_wd .code{
    color: #A2A2A2;
    font-size: 13px;
    margin-top: 5px;
}
.mask_wd .ipt{
    background-color: #F3F1F2;
    border-radius: 17px;
    height: 35px;
    width: 195px;
    margin: 0 auto;
    position: relative;
    padding: 5px 30px 5px 42px;
    margin-top: 15px;
}
.mask_wd .ipt input{
    font-size: 15px;
    color: #333;
    width: 120px;
    border: none;
    background-color: #F3F1F2;
    height: 25px;
    line-height: 25px;
}
.wechat_small{
    width: 21px;
    height: 17px;
    position: absolute;
    left: 15px;
    top: 8px;
}
.close_small{
    width: 17px;
    height: 17px;
    position: absolute;
    right: 9px;
    top: 8px;
}
.mask_wd .ipt input::-webkit-input-placeholder {
  color: #CECCCF;
}
.mask_wd .ipt input::input-placeholder {
  color: #CECCCF;
}
.mask_wd .btn{
    background-color: #FF512E;
    width: 195px;
    height: 35px;
    line-height: 35px;
    border-radius: 17px;
    color: #fff;
    font-size: 15px;
    border: none;
    margin: 15px auto 0;
    display: block;
}
.mask_wd  .van-button--disabled{
    background-color: #F3F1F2;
    color: #CECCCF;
}
.tp_main{
    padding: 15px;
    border-top: 2px solid #F8F8FA;
    margin-top: 20px;
}
.tp_main p{
    color: rgba(51, 51, 51, 0.8);
    font-size: 14px;
    line-height: 19px;
    padding-left: 20px;
    text-align: left;
    position: relative;
    margin-bottom: 5px;
}
.tp_main p.tit{
    color: rgba(51, 51, 51, 1);
    font-size: 13px;
    padding-left: 0;
    margin-bottom: 10px;
}
.tp_main p:last-child{
    margin-bottom: 0;
    margin-top: 15px;
}
.tp_main p span{
    border: 1px solid rgba(51, 51, 51, 0.8);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 14px;
    height: 14px;
    font-size: 10px;
    position: absolute;
    left: 0;
    top: 2.5px;
}
.mask_wd .close_btn{
    width: 52px;
    height: 52px;
    position: absolute;
    bottom: -65px;
    left: 50%;
    margin-left: -26px;
}
.no_list{
    color: rgba(51, 51, 51, 0.8);
    font-size: 15px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border-bottom: 5px solid #F6F6F6;
}
</style>